'use client';

import {
  PropsWithChildren,
  createContext,
  useCallback,
  useContext,
  useState,
} from 'react';

type FullMenuContextValue = {
  isOpen: boolean;
  toggle: () => void;
};

const FullMenuContext = createContext<FullMenuContextValue | null>(null);

export const FullMenuProvider = ({ children }: PropsWithChildren) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = useCallback(() => setIsOpen(state => !state), []);

  return (
    <FullMenuContext.Provider value={{ isOpen, toggle }}>
      {children}
    </FullMenuContext.Provider>
  );
};

export const useFullMenu = () => {
  const context = useContext(FullMenuContext);
  if (!context)
    throw new Error('useFullMenu은 FullMenuProvider에 속해야 합니다.');
  return context;
};
